import "vant/lib/loading/style";
import _Loading from "vant/lib/loading";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import NavBar from "@/components/nav/navBar.vue";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { convertImgToBase64 } from '@/utils/urlToBase64';
import { filterBase64PicPng } from "@/api/utils/apiHelper";

var BeautyContestScaning =
/*#__PURE__*/
function (_Vue) {
  _inherits(BeautyContestScaning, _Vue);

  function BeautyContestScaning() {
    var _this;

    _classCallCheck(this, BeautyContestScaning);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BeautyContestScaning).apply(this, arguments));
    _this.faceOneUrl = "";
    _this.faceTwoUrl = "";
    _this.starOne = "";
    _this.starTwo = "";
    return _this;
  }

  _createClass(BeautyContestScaning, [{
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
    }
  }, {
    key: "scaningPhoto",
    value: function () {
      var _scaningPhoto = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var queryTemp, cameraResultOne, cameraResultTwo, beautyContestResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //照片上传
                queryTemp = routerTempHelpers.getQueryTemp(this.$route.query);

                if (!this.starOne) {
                  _context.next = 19;
                  break;
                }

                _context.next = 4;
                return convertImgToBase64(this.faceOneUrl);

              case 4:
                cameraResultOne = _context.sent;
                console.log(cameraResultOne);
                cameraResultTwo = this.faceTwoUrl;

                if (!this.starTwo) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return convertImgToBase64(this.faceTwoUrl);

              case 10:
                cameraResultTwo = _context.sent;
                console.log(cameraResultOne);

              case 12:
                _context.next = 14;
                return this.beautyContestScaning({
                  cameraResultOne: filterBase64PicPng(cameraResultOne),
                  cameraResultTwo: filterBase64PicPng(cameraResultTwo)
                });

              case 14:
                beautyContestResult = _context.sent;
                console.log("beautyContestResult", beautyContestResult);

                if (beautyContestResult && beautyContestResult.length >= 2) {
                  this.routerReplace({
                    name: "beautyContestResult",
                    query: {
                      beautyContestResult: beautyContestResult,
                      imageData: {
                        picFileUrl: "",
                        cameraResultOne: filterBase64PicPng(cameraResultOne),
                        cameraResultTwo: filterBase64PicPng(cameraResultTwo)
                      },
                      transitionType: "forward"
                    }
                  });
                }

                _context.next = 20;
                break;

              case 19:
                if (queryTemp) {
                  queryTemp.nextStepFunction && queryTemp.nextStepFunction();
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function scaningPhoto() {
        return _scaningPhoto.apply(this, arguments);
      }

      return scaningPhoto;
    }()
  }, {
    key: "initData",
    value: function initData() {
      var queryTemp = routerTempHelpers.getQueryTemp(this.$route.query);
      var starOne = this.starOne = queryTemp.imageData.starOne;
      var starTwo = this.starTwo = queryTemp.imageData.starTwo;
      this.faceOneUrl = starOne ? queryTemp.imageData.cameraResultOne : "data:image/jpeg;base64," + queryTemp.imageData.cameraResultOne;
      this.faceTwoUrl = starTwo ? queryTemp.imageData.cameraResultTwo : "data:image/jpeg;base64," + queryTemp.imageData.cameraResultTwo;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.initData(); //执行上传,等动画完成:

      setTimeout(function () {
        _this2.scaningPhoto();
      }, 500);
    }
  }]);

  return BeautyContestScaning;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], BeautyContestScaning.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.BEAUTY_CONTEST)], BeautyContestScaning.prototype, "beautyContest", void 0);

tslib_1.__decorate([Action(types.BEAUTY_CONTEST_SCANIG)], BeautyContestScaning.prototype, "beautyContestScaning", void 0);

tslib_1.__decorate([Action(types.ROUTER_REPLACE)], BeautyContestScaning.prototype, "routerReplace", void 0);

BeautyContestScaning = tslib_1.__decorate([Component({
  components: {
    NavBar: NavBar,
    Loading: _Loading
  }
})], BeautyContestScaning);
export default BeautyContestScaning;